import React, { useContext, useEffect, useState } from 'react'
import { Transition } from 'semantic-ui-react'

import Feature from './Feature'
import { CampingStyleProps, SiteProps } from '../../interfaces'
import { validElectric } from '../../types'
import { BookerContext } from '../../contexts/BookerContext'
import CampImagesCarousel from '../ui/CampImagesCarousel'
import api from '../../api2'
import createMarkup from '../../utils/createMarkup'
import IS3Document from '../../interfaces/IS3Document'
import { useDebouncedCallback } from 'use-debounce'

interface ComponentProps {
  visible: boolean
  selectedSite: SiteProps
  nights: number
  confirmCallback: any
  userElectric: validElectric
  userCampingStyle: CampingStyleProps
  isFeaturesCuttedOff: boolean
  setSitePhotos: React.Dispatch<React.SetStateAction<Record<string, string[]>>>
  sitePhotos: Record<string, string[]>
  features: string[]
}

const Features = (props: ComponentProps) => {

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const sitePhotos = props.sitePhotos?.[props.selectedSite.id]

  const filteredFeatures = props.features.filter(
    (feature) =>
      props.selectedSite[feature] ||
      [
        "has_wifi",
        "electric",
        "water",
        "has_linens",
        "fire_pit",
        "picnic_table",
        "has_towels",
      ].includes(feature),
  )

  if(!filteredFeatures?.length){
    return <div className='mt-5'></div>
  }

  return (
    <div className='mt-2'>
      {props.visible && props.selectedSite ? (
        <div className='space-y-6'>
          <div className={props.userCampingStyle.is_showing_features ? 'pb-12' : 'pb-2'}>
            {props.selectedSite.notes && (
              <div
                className={`${
                  sitePhotos?.length > 0 ? 'pb-3' : 'pb-6'
                } html-editor-container text-left pt-3`}>
                <div dangerouslySetInnerHTML={createMarkup(props.selectedSite.notes)} />
              </div>
            )}
            {sitePhotos?.length > 0 && (
              <div className='w-full pb-6 relative' onClick={e => e.stopPropagation()}>
                <CampImagesCarousel
                  imageUrls={sitePhotos}
                  isLoading={isLoading}
                />
              </div>
            )}
            {props.userCampingStyle.is_showing_features && (
              <div className='grid xsm:grid-cols-2 grid-cols-1 gap-6'>
                {filteredFeatures
                  .slice(0, props.isFeaturesCuttedOff ? 6 : filteredFeatures.length)
                  .map((feature) => (
                    <Feature
                      key={feature}
                      name={feature as keyof SiteProps}
                      value={props.selectedSite[feature]}
                      site={props.selectedSite}
                      isShowingLabel={true}
                    />
                  ))}
              </div>
            )}
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default Features
